import { useEffect, useState } from "react";
import { useLazyQuery } from "@stadium/services/apollo-client";
import union from "lodash/union";
import uniq from "lodash/uniq";

import { fetchAdditionalProductsBasicDetailItems } from "@graphql/queries/stores/products/fetch-additional-product-basic-detail-items";
import { searchProductsSerializer } from "@serializers/search-products";

import { useFetchInventoryDetails } from "@hooks/product-detail/use-fetch-inventory";

const emptyArr = [];

const useFetchAdditionalProductsBasicDetailItems = ({ skipInventoryFetching = true } = {}) => {
  const [fetchedProductsFromBrand, setFetchedProductsFromBrand] = useState(emptyArr);
  const [fetchedRecommendedProducts, setFetchedRecommendedProducts] = useState(emptyArr);

  const { fetchInventoryDetails, isInventoryFetching, variantData } = useFetchInventoryDetails();

  const [getAdditionalProductDetails, { data, loading }] = useLazyQuery(
    fetchAdditionalProductsBasicDetailItems,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  const getUpdatedProducts = (data) => searchProductsSerializer(data?.products || emptyArr);

  useEffect(() => {
    const products = uniq(union(fetchedRecommendedProducts, fetchedProductsFromBrand));

    if (products.length && !skipInventoryFetching) {
      fetchInventoryDetails(products);
    }
  }, [
    fetchInventoryDetails,
    fetchedRecommendedProducts,
    fetchedProductsFromBrand,
    skipInventoryFetching,
  ]);

  useEffect(() => setFetchedProductsFromBrand(getUpdatedProducts(data?.productsFromBrand)), [data]);
  useEffect(
    () => setFetchedRecommendedProducts(getUpdatedProducts(data?.recommendedProducts)),
    [data],
  );

  return {
    fetchedProductsFromBrand,
    fetchedRecommendedProducts,
    isInventoryFetching,
    productsInventory: variantData,
    loading,
    getAdditionalProductDetails,
    data,
  };
};

export default useFetchAdditionalProductsBasicDetailItems;
